import React from "react";
import FieldConfig from "../../proto/field-config";
import FieldProto from "../../proto/field-proto";
import FieldReminder_View from "./render/view";
import Task from "../../../model2/task/task";
import FieldReminder_ViewSmall from "./render/view-small";
import FieldReminder_ViewReference from "./render/view-reference";

export default class FieldReminder extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Reminder";

        this.renderComponents.view          = FieldReminder_View
        this.renderComponents.viewSmall     = FieldReminder_ViewSmall
        this.renderComponents.viewReference = FieldReminder_ViewReference
        this.renderComponents.glistView     = FieldReminder_View
    }


    // normalize value for sorting
    sortValue(value:Task, model?:any) {
        return value ? value.title.toLowerCase() : ''
    }
}